<template>
  <div>
    <el-container direction="vertical">
      <div style="background-color: rgb(255, 255, 255); border: 1px solid #eee;">
        <div style="margin-top: 20px;">
          <el-form class="form" style="margin-left: 10px;">
            <!-- <el-form-item label="管理机构">
              <patientTree @input="input" :treeData="data"></patientTree>
            </el-form-item> -->
            <el-form-item label="患者姓名">
              <el-input v-model="listQuery.patientName"></el-input>
            </el-form-item>
            <!-- <el-form-item label="规范管理">
              <el-select v-model="listQuery.isDiabetStdManage" placeholder="请选择">
                <el-option label="全部" :value="null"></el-option>
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="来源" style="width: 160px;margin-left: 15px;">
              <el-select v-model="listQuery.fromSource" placeholder="请选择" @change="listQuery.fromSourceDeptId = emptyDepartmentSelection(listQuery.fromSourceDeptId)">
                <el-option v-for="x in sourceOptions" :key="x.value" :label="x.label" :value="x.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="科室" style="width: 160px;margin-left: 15px;">
              <el-select v-model="listQuery.fromSourceDeptId" filterable clearable placeholder="请选择">
                <el-option v-for="x in filterDepartmentOptions(deptsOptions, listQuery.fromSource)" :key="x.value" :label="x.label" :value="x.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="协诊时间" style="margin-left: 20px;">
              <el-date-picker v-model="valueData" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="任务状态" style="margin-left: 20px;">
              <el-select style="width: 200px;margin-left: 0px;" v-model="listQuery.taskStatus" placeholder="请选择">
                <el-option v-for="x in taskStatusOptions" :key="x.value" :label="x.label" :value="x.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" style="margin-left: 20px;" @click="getList">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" plain style="margin-left: 10px;margin-right: 20px;"
                @click="handleReset">重置</el-button>
            </el-form-item>
            <!-- <el-form-item>
              <el-button type="primary" @click="reportExportToExcel">导出</el-button>
            </el-form-item> -->
            <!-- <el-form-item>
              <el-button type="primary" style="margin-left: 20px;" @click="addReferralRequest">新增转诊申请</el-button>
            </el-form-item> -->
          </el-form>

          <!-- <el-row style="margin-bottom: 10px;margin-left: 15px;" direction="horizontal">
            <el-checkbox-group v-model="dateType" @change="handleCheckedDate">
              <el-checkbox label="超过24小时但小于72小时未就诊的患者" style="color: orange;"></el-checkbox>
              <el-checkbox label="超过72小时未就诊的患者" style="color: red;"></el-checkbox>
            </el-checkbox-group>
          </el-row> -->

          <el-table ref="myTable" v-loading="listLoading" :data="manageList" fit highlight-current-row>
            <el-table-column align="center" label="姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.patientName }}</span>
              </template>
            </el-table-column>

            <el-table-column width="80px" align="center" label="性别">
              <template slot-scope="scope">
                <span>{{ getGender(scope.row.gender) }}</span>
              </template>
            </el-table-column>

            <el-table-column width="80px" align="center" label="年龄">
              <template slot-scope="scope">
                <span>{{ getAge(scope.row.birthday) }}</span>
              </template>
            </el-table-column>

            <el-table-column width="200px" align="center" label="身份证号">
              <template slot-scope="scope">
                <span>{{ scope.row.idcard }}</span>
              </template>
            </el-table-column>

            <el-table-column width="150px" align="center" label="电话">
              <template slot-scope="scope">
                <span>{{ scope.row.phone }}</span>
              </template>
            </el-table-column>

            <el-table-column width="120px" align="center" label="来源">
              <template slot-scope="scope">
                <span>{{ scope.row.fromSource || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column width="200px" align="center" label="科室">
              <template slot-scope="scope">
                <span>{{ scope.row.fromSourceDeptName || '-' }}</span>
              </template>
            </el-table-column>

            <el-table-column min-width="300px" align="center" label="诊断">
              <template slot-scope="scope">
                <span>{{ scope.row.applyDiagnosis }}</span>
              </template>
            </el-table-column>

            <el-table-column width="100px" align="center" label="协诊状态">
              <template slot-scope="scope">
                <span>{{ scope.row.codiagStatus }}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column align="center" label="所属机构">
              <template slot-scope="scope">
                <span>{{ scope.row.managerHospital }}</span>
              </template>
            </el-table-column> -->

            <!-- <el-table-column align="center" label="诊断">
              <template slot-scope="scope">
                <el-button type="primary" @click="diagnose(scope.row)">开始诊断</el-button>
                <diagnoseDialog
                v-if="diagnoseVisible"
                ref="diagnoseRef"
              ></diagnoseDialog>
              </template>
            </el-table-column> -->

            <el-table-column fixed="right" width="300px" align="center" label="操作">
              <template slot-scope="scope">
                <el-button style="margin-left: 0px; align-self: center" type="text"
                  @click="codiag(scope.row)">一键协诊</el-button>
                <el-button style="margin-left: 5px; align-self: center" type="text"
                  @click="codiagDetail(scope.row)">协诊详情</el-button>
                <el-button style="margin-left: 5px; align-self: center" type="text"
                  @click="patientsDetail(scope.row)">健康档案</el-button>
                <el-button style="margin-left: 5px; align-self: center" type="text"
                  @click="initiateConsultation(scope.row)">发起会诊</el-button>
              </template>
            </el-table-column>
          </el-table>

          <diagnoseDialog v-if="diagnoseVisible" ref="diagnoseRef"></diagnoseDialog>
          <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>
          <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
            @pagination="turnToPage" />
          <addReferral v-if="addReferralVisible" ref="AddReferralRef"></addReferral>
          <consultationDetailDialog v-if="consultationDetailVisiable" ref="consultationDetail">
          </consultationDetailDialog>
          <codiagDiag v-if="codiagDiagVisible" ref="codiagDiagRef">
          </codiagDiag>
        </div>
      </div>
    </el-container>
  </div>
</template>
<script>
import {
  getSearchList,
  turnToMyListCodiag,
  getUserInfos,
  reportToExcel,
  getSysDicList,
  getlistCodiags,
  getByIdCoDiag,
  getDoctorListQlyyDepts
} from "@/api/health/Patients";
import patientDetail from "@/views/patient/patientDetail";
import diagnoseDialog from "./pressureRecordDialogs/diagnoseDialog.vue";
import Pagination from "@/components/Pagination";
import patientTree from "@/components/selectTree";
import addReferral from "../bloodGlucoseCollaborative/manage/addReferral.vue";
import { Loading } from "element-ui";
import moment from "moment";
import consultationDetailDialog from "../bloodGlucoseCollaborative/glucoseRecordDialogs/consultationDetailDialog.vue";
import codiagDiag from "../../integration/codiagDiag.vue";
import { filterDepartmentOptions, emptyDepartmentSelection } from "@/utils/source-dept-filter";

export default {
  components: { diagnoseDialog, patientDetail, patientTree, Pagination, addReferral, consultationDetailDialog, codiagDiag },
  props: {
    numType: String
  },
  watch: {
    numType(newValue, oldValue) {
      console.log(`Prop value changed from ${oldValue} to ${newValue}.`);
      this.listQuery.type = newValue;
      this.getList();
    }
  },
  data() {
    return {
      valueData: null,
      manageList: [],
      patientDetailVisible: false,
      diagnoseVisible: false,
      addReferralVisible: false,
      consultationDetailVisiable: false,
      codiagDiagVisible: false,
      listLoading: false,
      dateType: [],
      total: 0,
      data: null,
      loadingOptions: {
        text: "正在导出...",
        background: "rgba(0, 0, 0, 0.6)",
      },
      listQuery: {
        idcard: null,
        patientName: null,
        serviceName: '高血压协诊',
        type: '',
        // isIntegrateManage: 1,
        noVisitHoursStart: null,
        noVisitHoursEnd: null,
        codiagHospital: null,
        codiagStatus: null,
        codiagStartTime: null,
        codiagEndTime: null,
        codiagDealResult: null,
        fromSource: null,
        fromSourceDeptId: null,
        pageNum: 1,
        pageSize: 10,
        taskStatus: null
      },
      taskStatusOptions: [
        { label: '全部', value: null },
        { label: '协诊', value: '协诊' },
        { label: '待就诊', value: '待就诊' },
        { label: '协诊超时', value: '协诊超时' }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      exportBody: {
        url: "/business/ehr/search",
        headers: ['姓名', '性别', '年龄', '电话', '规范管理', '所属机构'],
        keys: ["name", "gender", "birthday", "phone", "isDiabetStdManage", "managerHospital"],
        body: null,
      },
      sexOptions: [],
      sourceOptions: [],
      deptsOptions: [],
    };
  },
  created() {
    var typeData = "性别";
    this.getSystemDictList(typeData);
    this.getSourceSystemDictList("指标来源");
    this.getMasterData('depts');
    this.getList();
  },
  methods: {
    filterDepartmentOptions,
    emptyDepartmentSelection,
    handleReset() {
      this.listQuery = {
        ...this.listQuery,
        patientName: null,
        codiagStartTime: null,
        codiagEndTime: null,
        fromSource: null,
        fromSourceDeptId: null,
        taskStatus: null,
        pageNum: 1,
        pageSize: 10,
      }
      this.valueData = null;
      this.getList();
    },
    handleCheckedDate(value) {
      console.log(value);
      if (value.length == 2) {
        this.listQuery.noVisitHoursStart = null;
        this.listQuery.noVisitHoursEnd = -24;
      } else if (value.length == 0) {
        this.listQuery.noVisitHoursStart = null;
        this.listQuery.noVisitHoursEnd = null;
      } else if (value.length == 1) {
        if (value[0] == '超过24小时但小于72小时未就诊的患者') {
          this.listQuery.noVisitHoursStart = -72;
          this.listQuery.noVisitHoursEnd = -24;
        } else {
          //超过72小时未就诊
          this.listQuery.noVisitHoursStart = null;
          this.listQuery.noVisitHoursEnd = -72;
        }
      }
    },
    getSourceSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        this.sourceOptions = records?.map(x => ({ label: x.name, value: x.name }));
        this.sourceOptions = [{ label: "全部", value: null }, ...this.sourceOptions]
      }).catch(err => {
        console.log(err);
      })
    },
    async getMasterData(field, params) {
      try {
        if (field === 'depts') {
          const res = await getDoctorListQlyyDepts({ isAll: "1" })
          if (res.msg == "success") {
            this.deptsOptions = [{ label: '全部', value: null }, ...res.data?.map(x => ({ label: x.deptName, value: x.deptId, type: x.type })) || []];
          }
        }
      } catch (err) {
        console.warn(err);
      }
    },
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        this.sexOptions = records;
        console.log(this.sexOptions);
      }).catch(err => {
        console.log(err);
      })
    },
    getGender(gender) {
      var option = this.sexOptions.filter(v => v.value == gender)[0];
      return option.name;
    },
    //获取表头
    getTableHead() {
      var columnTitle = [];
      this.$refs.myTable.$children.forEach((obj) => {
        console.log("obj:", obj);
        if (obj.label != undefined) {
          columnTitle.push(obj.label);
        }
      });
      console.log("columnTitle:", columnTitle);
    },
    //查询结果导出
    reportExportToExcel() {
      console.log(
        "查询结果导出",
        `表格${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
      );

      let loadingInstance = Loading.service(this.loadingOptions);

      this.exportBody.url = '/business/ehr/search?page=' + this.listQuery.pageNum + '&pageSize=' + this.listQuery.pageSize;

      this.exportBody.body = this.listQuery;
      console.log("导出表格请求body：", this.exportBody);

      reportToExcel(this.exportBody)
        .then((res) => {
          console.log("查询表格导出====", res);

          this.$nextTick(() => {
            loadingInstance.close();
          });

          let blob = new Blob([res], { type: "application/force-download" });
          console.log(blob);
          let fileReader = new FileReader();
          fileReader.readAsDataURL(blob);
          fileReader.onload = (e) => {
            let a = document.createElement("a");
            a.download = `高血压协诊管理-我管理的${moment(new Date()).format(
              "YYYYMMDDHHmm"
            )}.xlsx`;
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        })
        .catch((error) => {
          this.$nextTick(() => {
            loadingInstance.close();
          });

          console.log(error);

          this.$message({
            message: "导出失败",
            type: "error",
          });
        });
    },
    // 选取机构
    input(value) {
      // this.listQuery.managerHospitals = value;
    },
    // 导航跳转查询列表页
    turnToPage() {
      this.listLoading = true;
      if (!this.listQuery.fromSourceDeptId) {
        this.listQuery.fromSourceDeptId = null;
      }
      this.listQuery.codiagStartTime = this.valueData ? this.getParseDate(this.valueData[0], 1) : null;
      this.listQuery.codiagEndTime = this.valueData ? this.getParseDate(this.valueData[1], 2) : null;

      this.listQuery.type = this.numType;

      turnToMyListCodiag(this.listQuery).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 跳转诊断列表
    diagnose(rowValue) {
      this.diagnoseVisible = true;
      this.$nextTick(() => {
        this.$refs["diagnoseRef"].init(rowValue);
      });
    },
    //一键协诊
    codiag(rowValue) {
      this.codiagDiagVisible = true;

      console.log('一键协诊：', rowValue);

      this.$nextTick(() => {
        this.$refs['codiagDiagRef'].init(rowValue);
      })
    },
    // 协诊详情
    codiagDetail(data) {
      this.consultationDetailVisiable = true;
      const params = {
        id: data.id
      }
      getByIdCoDiag(params).then(res => {
        if (res.msg == "success") {
          data = res.data;
          this.$nextTick(() => {
            this.$refs["consultationDetail"].init(data)
          })
        }
      })
    },
    //协诊-我管理的
    getList() {
      this.listLoading = true;
      if (!this.listQuery.fromSourceDeptId) {
        this.listQuery.fromSourceDeptId = null;
      }
      this.listQuery.codiagStartTime = this.valueData ? this.getParseDate(this.valueData[0], 1) : null;
      this.listQuery.codiagEndTime = this.valueData ? this.getParseDate(this.valueData[1], 2) : null;

      this.listQuery.type = this.numType;

      getlistCodiags(this.listQuery).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
          // this.getTableHead();
        }
      });
    },
    // 計算年齡
    getAge(birthday) {
      if (birthday == null) return "";
      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
    // 跳转至相应病人档案详情页
    patientsDetail(row) {
      this.patientDetailVisible = true;
      this.$nextTick(() => {
        this.$refs["PatientDetailRef"].init(row);
      });
    },
    //发起会诊
    initiateConsultation(row) {

    },
    addReferralRequest() {
      this.addReferralVisible = true;
      this.$nextTick(() => {
        this.$refs["AddReferralRef"].init();
      });
    },
    // 日期格式转化
    getParseDate(time, type) {
      if (type == 1) {
        var newTime = new Date(time);
      } else if (type == 2) {
        var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
      }
      // 获取完整的年份(4位)
      var year = newTime.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = newTime.getMonth() + 1;
      // 获取日期(1-31)
      var date = newTime.getDate();

      return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
    },
  },
};
</script>
<style lang="scss" scoped>
.form {
  display: flex;
  flex-wrap: wrap;

  ::v-deep {
    .el-form-item {
      margin-left: 5px;
    }

    .el-form-item__content {
      display: flex;
    }
  }
}
</style>
